import React from 'react';
import { useTranslation } from 'react-i18next';

import ConceptSection from './ConceptSection';
import NegativeConceptChart from '../charts/NegativeConceptChart';

function NegativeSection({ selectedConcept, isGlobalPercentageEnabled }) {
  const { t } = useTranslation('resonance');

  return (
    <ConceptSection
      title={t('negative')}
      selectedConcept={selectedConcept}
      isGlobalPercentageEnabled={isGlobalPercentageEnabled}>
      {({ compareConcepts, isGlobalPercentage }) => (
        <NegativeConceptChart
          compareConcepts={compareConcepts}
          selectedConcept={selectedConcept}
          isGlobalPercentage={isGlobalPercentage}
        />
      )}
    </ConceptSection>
  );
}

export default NegativeSection;
